ApiAjax = require 'network/api-ajax'
Auth = require 'db/auth'
PopOver = require 'views/lib/pop-over'
Util = require 'lib/util'
View = require 'view'
template = require 'views/templates/billing_contact'
supportedLocales = require('common/data/supported-locales').default

module.exports = class ChangeBillingInfoView extends View
  viewTitleKey: 'change billing contact'

  events:
    'click .js-submit': 'changeBillingContact'
    'submit form': 'changeBillingContact'

  render: ->
    paidAccount = @model.get('paidAccount')
    data = if paidAccount
      fullName: paidAccount.contactFullName
      email: paidAccount.contactEmail
      locale: paidAccount.contactLocale
    else
      fullName: Auth.me().get('fullName')
      email: Auth.me().get('email')
      locale: Auth.me().getLocale()

    # Ensure that we default to English istead of Czech
    # (which is otherwise the first value in the select)
    isLocaleSupported = data.locale &&
      supportedLocales.some ({ code }) ->
        code.toLowerCase() == data.locale.toLowerCase()

    if !isLocaleSupported
      data.locale = 'en-US'

    @$el.html template(data)

    @

  changeBillingContact: (e) ->
    Util.stop(e)

    data = {}
    data.billingContactFullName = @$('input#billingContactFullName').val()
    data.billingContactEmail = @$('input#billingContactEmail').val()
    data.billingContactLocale = @$('select#billingContactLocale').val()

    @$('.js-submit').attr('disabled', 'disabled')
    for field in ['billingContactFullName', 'billingContactEmail', 'billingContactLocale']
      @$("##{field}").removeClass('input-error')

    ApiAjax
      url: "#{ @model.urlRoot }/#{ @model.id }/paidAccount/billingContact"
      data: data
      type: 'POST'
      success: (resp) =>
        @model.set(resp)
        PopOver.hide()
      error: (req) =>
        err = req.responseText ? "error"
        @$('.js-submit').removeAttr('disabled', 'disabled')
        if /billingContactFullName/.test(err)
          @$('#billingContactFullName').addClass('input-error')
          return
        if /email/.test(err)
          @$('#billingContactEmail').addClass('input-error')
          return
        if /locale/.test(err)
          @$('#billingContactLocale').addClass('input-error')
          return
        @$('.error').text(err).show()



// WEBPACK FOOTER //
// ./app/scripts/views/billing/change-billing-info-view.coffee